"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const M = require("./matchers");
function create(items) {
    return {
        search(term) {
            const matcher = M.get(term.field, term.value, term);
            return items
                .filter(item => typeof item.manifest === "object")
                .filter(item => (term.negated ? !matcher(item) : matcher(item)))
                .map(i => i.id);
        }
    };
}
exports.create = create;
//# sourceMappingURL=registry.js.map